
//  Link media
require.context('../media/', true, /^\.\/.*\.*/);
require.context('../fonts/', true, /^\.\/.*\.*/);


//  Styles
import '../styles/styles.scss';

// JS


import lazysizes from 'lazysizes';
// import Rellax from 'rellax';
import utils from './proj/utils';

import $ from 'jquery';
import Waypoint from 'Waypoint';




$(document).ready(function(){

  if( FAVEPlayer ) {
    FAVEPlayer.create("fave_video");
  }

  let loaded = 0;
  document.addEventListener('lazybeforeunveil', function(e){
    if( e.target && e.target.id && (e.target.id === 'harryImg' || e.target.id === 'meghanImg') ){
      loaded++;
      if(loaded === 2) {
        $('body').addClass('start-app');
      }
    }
  });


  // lazy sizes config
  lazysizes.cfg.customMedia = {
      '--device': '(max-width: 800px)',
      '--laptop': '(max-width: 1200px)',
      '--desktop': '(max-width: 1440px)',
  };




  const timeline = document.querySelector('ul.timeline');
  const $couple = $('.royal-couple');
  const $harry = $('.royal-couple__entity--harry');
  const $meghan = $('.royal-couple__entity--meghan');
  const $header = $('.header');
  const $body = $('body');



  const resizeHeader = function(w,h) {
    let initialWidth = w;
    let initialHeight = h;

    return function() {
      const landscape = window.innerWidth > window.innerHeight;
      if( utils.mobileAndTabletCheck() && initialHeight > 100  ) {
        const newH = ( window.innerWidth === initialWidth ) ? initialHeight : initialWidth;
        $header.css( { height: newH + 'px'} );
      }
    }

  }( window.innerWidth, window.innerHeight );

  resizeHeader();



  const scrollHandler = function() {
    const rect = timeline.getBoundingClientRect();
    const offset = window.innerHeight * 0.5;
    const h = rect.bottom - rect.top;
    const dist =  rect.top - offset;
    const pct = (dist >= 0) ? 0 : (h + dist <= 0) ? 1 : (dist * -1) / h;

    const isMob = window.innerWidth < 800;
    const halfWidth = $couple.width()/2;
    let harryRange, meghanRange;

    if( isMob ) {
      if( window.innerWidth < 350 ) {
        harryRange = { start: -40, end: halfWidth - 80 };
        meghanRange = { start: 30, end: -halfWidth + 70 };
      } else {
        harryRange = { start: -10, end: halfWidth - 80 };
        meghanRange = { start: 0, end: -halfWidth + 70 };
      }
    } else {
      harryRange = { start: 0, end: halfWidth - 135 };
      meghanRange = { start: 0, end: -halfWidth + 105 };
    }

    let harryPos = Math.floor( utils.mapRange( pct, 0, 1, harryRange.start, harryRange.end ) );
    let meghanPos = Math.floor( utils.mapRange( pct, 0, 1, meghanRange.start, meghanRange.end ) );

    $harry.css('transform', 'translateX(' + harryPos + 'px)');
    $meghan.css('transform', 'translateX(' + meghanPos + 'px)');


  }

  const onScrollThrottled = utils.throttle( scrollHandler, 100 );
  const onScrollDebounced = utils.debounce( scrollHandler, 300 );

  const onScroll = () => {
    onScrollThrottled();
    onScrollDebounced();
  }

  $(window).on('scroll', onScroll);


  onScroll();

  let minimizePoint, stickyPoint;

  const updatePoints = () => {
    if( window.innerWidth > 800 ) {
      minimizePoint = 280;
      stickyPoint = 204;
    } else {
      minimizePoint = 230;
      stickyPoint = 154;
    }
  }

  updatePoints();

  $(window).on('resize', updatePoints);

  let waypoints = [];

  $.each( $header, function(idx, el) {

    waypoints.push(
      new Waypoint({
        element: el,
        handler: function(dir) {
          var $el = $(el);
          if( dir === 'down') {
            $el.addClass('has-scrolled');
          } else {
            $el.removeClass('has-scrolled');
          }

        },
        offset: -10
      })
    );

    // minimize royal couple area
    waypoints.push(
      new Waypoint({
        element: el,
        handler: function(dir) {
          var $el = $(el);
          if( dir === 'down') {
            $body.addClass('minimized');
          } else {
            $body.removeClass('minimized');
          }

        },
        offset: function() { return -this.element.clientHeight + minimizePoint; }
      })
    );

    // minimize royal couple area
    waypoints.push(
      new Waypoint({
        element: el,
        handler: function(dir) {
          var $el = $(el);
          console.log('sticky check', dir);
          if( dir === 'down') {
            $el.addClass('sticky').removeClass('not-sticky');
          } else {
            $el.addClass('not-sticky').removeClass('sticky');
          }
        },
        offset: function() { return -this.element.clientHeight + stickyPoint; }
      })
    );

    // begin pulse
    // waypoints.push(
    //   new Waypoint({
    //     element: el,
    //     handler: function(dir) {
    //       var $el = $(el);
    //       if( dir === 'down') {
    //         $el.addClass('pulse');
    //       } else {
    //         $el.removeClass('pulse');
    //       }
    //     },
    //     offset: function() { return -this.element.clientHeight; }
    //   })
    // );


  });

  // $.each( $('.royal-couple__container'), function(idx, el) {
    // minimize royal couple area


  // });

  // $.each( $('.timeline__txt-content'), function(idx, el) {
  //   // right images
  //   waypoints.push(
  //     new Waypoint({
  //       element: el,
  //       handler: function(dir) {
  //         var $el = $(el);
  //         if( dir === 'down') {
  //           // $el.addClass('a-reveal-from-right');
  //           $el.addClass('a-reveal-up-in');
  //           this.destroy();
  //         }
  //
  //       },
  //       offset: '70%'
  //     })
  //   );
  // });


  $.each( $('.timeline__fig.a-type-right .image'), function(idx, el) {
    // right images
    waypoints.push(
      new Waypoint({
        element: el,
        handler: function(dir) {
          var $el = $(el);
          if( dir === 'down') {
            // $el.addClass('a-reveal-from-right');
            $el.addClass('a-reveal-up-in');
            this.destroy();
          }

        },
        offset: '80%'
      })
    );
  });

  $.each( $('.timeline__fig.a-type-left .image'), function(idx, el) {
    // left images
    waypoints.push(
      new Waypoint({
        element: el,
        handler: function(dir) {
          var $el = $(el);
          if( dir === 'down') {
            // $el.addClass('a-reveal-from-left');
            $el.addClass('a-reveal-up-in');
            this.destroy();
          }

        },
        offset: '80%'
      })
    );
  });

  $.each( $('.timeline__item--finale'), function(idx, el) {
    // header image change based on last timeline image
    waypoints.push(
      new Waypoint({
        element: el,
        handler: function(dir) {
          if( dir === 'down') {
            $header.removeClass('pulse').addClass('finale');
          } else {
            $header.removeClass('finale').addClass('pulse');
          }

        },
        offset: '80%'
      })
    );
  });




  const heightCheck = function(h) {

    let curHeight = h;
    return function() {
      let newHeight = $('body').height();
      if(newHeight !== curHeight) {
        Waypoint.refreshAll();
        curHeight = newHeight;
      }
    }
  }( $('body').height() );

  setTimeout( heightCheck, 5000 );


  $( window ).on( "orientationchange", function( event ) {
    resizeHeader();
  });


});



// WEBPACK FOOTER //
// ./src/js/main.js